import React, { useState, useRef } from 'react'
import './FinishAccountSetup.css'
import BillingComponent from '../../components/billing/BillingComponent'
import { formatAmounts, formatDateNoHour } from './../../utilities/generalUtils'
import { GpButton, Icon } from '../../components/gp'

const FinishAccountSetup = (props) => {
    const completeButtonText = props.isGuestCharging
        ? 'Finish setup'
        : 'Finish setup & download app'
    const [displayPayment, setDisplayPayment] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [formReady, setFormReady] = useState(false)
    const billingRef = useRef()

    const handleFinish = async () => {
        if (!billingRef.current) return
        setSubmitting(true)
        try {
            await billingRef.current.handleSubmit()
        } finally {
            setSubmitting(false)
        }
    }

    const description = props.isRecurring ? (
        <>
            Please provide your credit card information.{' '}
            <strong style={{ fontWeight: 500 }}>
                {formatAmounts(props.funds, false)}
            </strong>{' '}
            will be charged each month. You'll first be billed on{' '}
            <strong style={{ fontWeight: 500 }}>
                {formatDateNoHour(props.nextBillDate)}
            </strong>{' '}
            once you've been approved by your property manager.
        </>
    ) : (
        <>
            Please provide your credit card information.{' '}
            <strong style={{ fontWeight: 500 }}>${props.funds}</strong> will be charged
            once you've been approved by your property manager and again whenever your
            balance falls below <strong style={{ fontWeight: 500 }}>$10</strong>. No
            subscription fees — you only pay for the electricity you use.
        </>
    )

    return (
        <div style={{ maxWidth: 560, margin: '0 auto' }}>
            <p
                style={{
                    font: 'var(--gp-body)',
                    color: 'var(--gp-ink-mute)',
                    textAlign: 'center',
                    margin: '0 0 24px',
                    lineHeight: 1.5,
                }}
            >
                {props.isGuestCharging
                    ? `Thanks ${props.name || ''}. Add a payment method to activate. Your card won't be billed until your charging session ends.`
                    : description}
            </p>

            {props.isGuestCharging && !displayPayment ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <GpButton
                        variant="primary"
                        onClick={() => setDisplayPayment(true)}
                        style={{ minWidth: 220 }}
                    >
                        Enter payment details
                    </GpButton>
                </div>
            ) : (
                <>
                    <BillingComponent
                        ref={billingRef}
                        setPaymentMethodId={props.setPaymentMethodId}
                        creditCardAdded={props.creditCardAdded}
                        setParentLoading={setSubmitting}
                        onReadyChange={setFormReady}
                        buttonText={completeButtonText}
                    />

                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 12,
                            marginTop: 18,
                            padding: '12px 14px',
                            background: 'var(--gp-card)',
                            border: '1px solid var(--gp-hairline)',
                            borderRadius: 'var(--gp-r-md)',
                            font: 'var(--gp-caption)',
                            color: 'var(--gp-ink-mute)',
                        }}
                    >
                        <span
                            style={{
                                color: 'var(--gp-brand)',
                                display: 'inline-flex',
                                flexShrink: 0,
                            }}
                        >
                            <Icon name="shield" size={16} />
                        </span>
                        Your payment details are encrypted and processed by Stripe.
                        GoPower never stores your card number.
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 24,
                        }}
                    >
                        <GpButton
                            variant="primary"
                            onClick={handleFinish}
                            disabled={submitting || !formReady}
                            style={{ minWidth: 260 }}
                        >
                            {submitting ? 'Submitting…' : completeButtonText}
                        </GpButton>
                    </div>
                </>
            )}
        </div>
    )
}

export default FinishAccountSetup
